import React, { useState, useEffect, Fragment } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import {
  dateFormat,
  getTodayDateISO,
  numberFormat,
  refreshPage,
  toastStyle,
} from "../../../Helpers/Utils/Common";
import Navbar from "../../../Components/Navbar/Navbar";
import Moment from "moment";
//api
import CashAdvanceModal from "./../CashAdvance/CashAdvanceModal";
import { getPayroll, printPayroll } from "./../../../Helpers/apiCalls/Employees/PayrollApi";
import signature from "./../../../Assets/Images/signature.png";
import Footer from "../../../Components/Footer/Footer";

function ViewPayroll() {
  //variables
  const { id } = useParams();
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(true);
  const [addDetails, setAddDetails] = useState({
    employee_id: "",
    payroll_date: "",
    payroll_month: "",
    rate: "",
    total_working_days: "",
    basic_pay: 0,
    total_deduction: 0,
    total_addition: 0,
    grand_total: 0,
    rent: 0,
  });
  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false);
  const handleShowPrintModal = () => setShowPrintModal(true);
  const handleClosePrintModal = () => setShowPrintModal(false);

  // FUNCTIONS
  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print(printContents);
    document.body.innerHTML = originalContents;
    refreshPage();
  }

  async function handlePrintPI() {
    toast.loading("Printing Details", { style: toastStyle() });
    handleClosePrintModal();
    setTimeout(() => {
      toast.dismiss();
      Print();
      handlePrintStatus()
    }, 1000);
  }

  async function handlePrintStatus() {
    const response = await printPayroll([addDetails]);
    if (response.data) {
        
    } else {
        toast.error("Error changing status to print", {
            style: toastStyle(),
        });
    }
}
  //API

  async function fetchData() {
    setAddDetails([]);

    const response = await getPayroll(id);

    if (response.error) {
      // TokenExpiry(response);
    } else {
      var expense = response.data.data.map((data) => {
        var info = data;
        // var cashAdvanceTotals = [];
        info.month =
          dateFormat(data.date_from) + " - " + dateFormat(data.date_to);
        return info;
      });
      setAddDetails(expense[0]);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th className="text-start">Employee Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {/* className="req-table-w-border-bottom" */}
            <td className="franchise-td-gray text-start bolder req-table-w-border-left">
              Name
            </td>
            <td className="franchise-td-gray text-end">
              {addDetails.employee_name}
            </td>

            <td className="franchise-td-gray text-start bolder req-table-w-border-left">
              Rate
            </td>
            <td className="franchise-td-gray text-end">
              {numberFormat(addDetails.rate)}
            </td>

            <td className="franchise-td-gray text-start bolder req-table-w-border-left">
              Disbursement Type
            </td>
            <td className="franchise-td-gray text-end req-table-w-border-right">
              {addDetails.disbursement_type?.toUpperCase()}
            </td>
          </tr>
          {addDetails.employee_type !== "department head" && (
            <>
              <tr>
                <td className="franchise-td-gray text-start bolder req-table-w-border-left">
                  Scheduled Work Days
                </td>
                <td className="franchise-td-gray text-end">
                  {addDetails.scheduled_work_days
                    ? numberFormat(addDetails.scheduled_work_days)
                    : 0}
                </td>
                {parseInt(addDetails.scheduled_work_days) !== 0 && (
                  <>
                    <td className="franchise-td-gray text-start bolder req-table-w-border-left">
                      Worked Days
                    </td>
                    <td className="franchise-td-gray text-end">
                      {addDetails.working_days
                        ? numberFormat(addDetails.working_days)
                        : 0}
                    </td>

                    <td className="franchise-td-gray text-start bolder req-table-w-border-left">
                      Absent
                    </td>
                    <td className="franchise-td-gray text-end req-table-w-border-right">
                      {addDetails.absences
                        ? numberFormat(addDetails.absences)
                        : 0}
                    </td>
                  </>
                )}
                {parseInt(addDetails.scheduled_work_days) === 0 && (
                  <>
                    <td className="franchise-td-gray text-start bolder req-table-w-border-left">
                      Worked Hours
                    </td>
                    <td className="franchise-td-gray text-end req-table-w-border-right">
                      {addDetails.working_hours
                        ? numberFormat(addDetails.working_hours)
                        : 0}
                    </td>
                  </>
                )}
              </tr>
              <tr>
                {parseInt(addDetails.scheduled_work_days) !== 0 && (
                  <>
                    <td className="franchise-td-gray text-start bolder req-table-w-border-left">
                      Worked Hours
                    </td>
                    <td className="franchise-td-gray text-end">
                      {addDetails.working_hours
                        ? numberFormat(addDetails.working_hours)
                        : 0}
                    </td>

                    <td className="franchise-td-gray text-start bolder req-table-w-border-left">
                      Undertime
                    </td>
                    <td className="franchise-td-gray text-end">
                      {addDetails.undertime_hours
                        ? numberFormat(addDetails.undertime_hours)
                        : 0}
                    </td>

                    <td className="franchise-td-gray text-start bolder req-table-w-border-left">
                      Overtime
                    </td>
                    <td className="franchise-td-gray text-end req-table-w-border-right">
                      {addDetails.overtime_hours
                        ? numberFormat(addDetails.overtime_hours)
                        : 0}
                    </td>
                  </>
                )}
              </tr>
            </>
          )}
        </tbody>
      </Table>
    );
  }

  function renderTableEarnings() {
    return (
      <Table className="">
        <thead>
          <tr>
            <th className="text-start">Wages</th>
            <th className="text-end">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="franchise-td-gray text-start">Basic Pay</td>
            <td className="franchise-td-gray text-end">
              {numberFormat(addDetails.basic_pay)}
            </td>
          </tr>
          {parseInt(addDetails.transportation_allowance) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">
                Transportation Allowance
              </td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.transportation_allowance)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.other_allowances) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">Other Allowances</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.other_allowances)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.holidays) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">Holidays</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.holidays)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.thirteenth_month) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">13th Month</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.thirteenth_month)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.bonus) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">Bonus</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.bonus)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.service_incentive) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">
                Service Incentive
              </td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.service_incentive)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.other_wages) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">
                {addDetails.other_wages_description}
              </td>
              <td className="franchise-td-gray text-end">
                {addDetails.other_wages !== null &&
                parseInt(addDetails.other_wages) !== 0
                  ? numberFormat(addDetails.other_wages)
                  : ""}
              </td>
            </tr>
          )}
          {addDetails.overtime_pay &&
            parseInt(addDetails.overtime_pay) !== 0 && (
              <tr>
                <td className="franchise-td-gray text-start">Overtime Pay </td>
                {/* {addDetails.overtime_additional ? "30%" : ""} */}
                <td className="franchise-td-gray text-end">
                  {addDetails.overtime_pay !== null &&
                  parseInt(addDetails.overtime_pay) !== 0
                    ? numberFormat(addDetails.overtime_pay)
                    : ""}
                </td>
              </tr>
            )}
          <tr className="req-table-w-border-top">
            <td className="franchise-td-gray text-start">Gross Wages</td>
            <td className="franchise-td-gray green text-end">
              {numberFormat(
                parseFloat(addDetails.total_addition) +
                  parseFloat(addDetails.basic_pay) +
                  parseFloat(addDetails.overtime_pay)
              )}
            </td>
          </tr>
          <tr>
            <td className="franchise-td-gray text-start">Total Deductions</td>
            <td className="franchise-td-gray red text-end">
              -{numberFormat(addDetails.total_deduction)}
            </td>
          </tr>
          <tr>
            <td className="franchise-td-gray-last text-start bolder green bigger">
              Net Pay
            </td>
            <td className="franchise-td-gray-last green text-end bigger">
              {numberFormat(addDetails.grand_total)}
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }

  function renderTableDeductions() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th className="text-start">Deductions</th>
            <th className="text-end">Amount</th>
          </tr>
        </thead>
        <tbody>
          {parseInt(addDetails.philhealth) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">PhilHealth</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.philhealth)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.sss) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">SSS</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.sss)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.pagibig) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">Pag-Ibig</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.pagibig)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.sss_loan) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">SSS Loan</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.sss_loan)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.pagibig_loan) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">Pag-Ibig Loan</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.pagibig_loan)}
              </td>
            </tr>
          )}
          {parseInt(addDetails.shortage) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">Total Shortage</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.shortage)}
              </td>
            </tr>
          )}
          {/* {
                        parseInt(addDetails.cash_advance) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Total Cash Advance</td>
                                <td className="franchise-td-gray text-end">{numberFormat(addDetails.cash_advance)}</td>
                            </tr>
                        )
                    } */}
          {addDetails.cash_advances?.map((ca) => {
            return (
              <tr>
                <td className="franchise-td-gray text-start">
                  {ca.type.split("_")[0] + " " + ca.type.split("_")[1]}
                </td>
                <td className="franchise-td-gray text-end">
                  {numberFormat(ca.amount)}
                </td>
              </tr>
            );
          })}
          {parseInt(addDetails.other_deductions) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">
                {addDetails.other_deductions_description}
              </td>
              <td className="franchise-td-gray text-end">
                {addDetails.other_deductions !== null &&
                parseInt(addDetails.other_deductions) !== 0
                  ? numberFormat(addDetails.other_deductions)
                  : ""}
              </td>
            </tr>
          )}
          {parseFloat(addDetails.rent) !== 0 && (
            <tr>
              <td className="franchise-td-gray text-start">Rent</td>
              <td className="franchise-td-gray text-end">
                {numberFormat(addDetails.rent)}
              </td>
            </tr>
          )}

          {/* <tr>
                        <td colSpan={2}> <hr/> </td>
                    </tr> */}
          <tr className="req-table-w-border-top">
            <td className="franchise-td-gray text-start">Total Deductions</td>
            <td className="franchise-td-gray red text-end">
              {numberFormat(addDetails.total_deduction)}
            </td>
          </tr>
          {/* <tr>
                        <td className="franchise-td-gray text-start bolder">Net Salary</td>
                        <td className="franchise-td-gray green text-end">{numberFormat(addDetails.grand_total)}</td>
                    </tr> */}
        </tbody>
      </Table>
    );
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PAYROLL"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* header */}
        <div className="d-flex justify-content-between align-items-center my-3 pb-4">
          <h1 className="page-title mb-0">VIEW PAYROLL</h1>
        </div>

        <div
          // display-none
          className="print-container px-3 py-2 "
          id="printablediv"
        >
          <div className="text-end print-header d-flex flex-column">
            <span>PAYSLIP</span>
            <span className="text-uppercase">
              {Moment(addDetails.disbursement_date).format("MMMM DD, yyyy")}
            </span>
          </div>
          <div className="d-flex justify-content-center py-1 mt-1">
            <h5 className="print-shop-header">
              TRIPLE K EXPRESSFOODS / 3K EXPRESSFOODS / CHK BUSINESS VENTURES
              CORP
            </h5>
          </div>
          <div className="d-flex justify-content-center py-1 mt-1">
            <h3 className="print-shop-header">{addDetails.month}</h3>
          </div>

          <div className="print-body">
            <div className="d-flex  mt-2 mb-2 justify-content-evenly">
              <div className="print-table mt-3 mx-5">{renderTable()}</div>
            </div>
            <div className="d-flex mt-2 justify-content-evenly">
              <div className="print-table ms-5 me-2 baseline">
                {renderTableDeductions()}
              </div>
              <div className="print-table me-5 ms-2 baseline">
                {renderTableEarnings()}
              </div>
            </div>
            <Row className="mt-2">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img src={signature} className="print-logo" />
              </Col>
              <Col
                xs={6}
                className="print-sig justify-content-center d-flex"
              ></Col>
            </Row>
            <Row className="mt-2 mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                      APPROVERS NAME
                  <div className="margin-underline"></div>
                  Employer's Signature
                </Row>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  <div className="margin-underline"></div>
                  Employee's Signature
                </Row>
              </Col>
            </Row>
          </div>
        </div>

        <div className="d-flex justify-content-end pt-5 pb-3">
          <button
            type="button"
            className="button-secondary me-3"
            onClick={() => navigate("/payrollmultiple")}
          >
            Close
          </button>
          <button
            type="button"
            className="button-primary me-3"
            onClick={handleShowPrintModal}
          >
            Print
          </button>
        </div>
      </div>

      <CashAdvanceModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        text="print this payroll"
        page="transaction"
        handler={handlePrintPI}
      />
      <Footer/>
    </div>
  );
}

export default ViewPayroll;
